/* eslint-disable max-lines */
import "swiper/dist/css/swiper.css";
import "../../css/components/Carousel.scss";
import React, { Component } from "react";
import Swiper from "react-id-swiper";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";
import inView from "InView";
import store from "../store/configStore";
import { isTap, carouselPlayHandler, cloneMounted, pausedOnFullscreen } from "../store/actions/index";
import Dynamic from "./Dynamic";
import Logger from "../utils/Logger";
import g from "../utils/globals";
import dom from "../utils/dom";
import { getRatio, isHomeMobile, bgColor, toCamelCase, defaultSection } from "../utils/helpers";
import { features } from "../utils/features";
import api from "../utils/api";
import { getAnalyticsSpot } from "../utils/analytics";
import { changeMessage, closeMessage } from "../store/actions/index";

const logger = new Logger(__filename);

class Carousel extends Component {
  constructor(...args) {
    super(...args);
    this.swiper = null;
    this.looped = false;
    this.scrollY = 0;
    const autoplay = {
      delay: 3500,
      disableOnInteraction: false,
    };
    this.state = {
      editMode: false,
      params: {
        direction: "horizontal",
        mousewheel: {
          forceToAxis: true,
        },
        runCallbacksOnInit: false,
        initialSlide: this.getInitialSlide(),
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: this.props.autoplay ? autoplay : false,
        loop: this.props.loop,
        speed: 1000,
        on: {
          slideChange: this.slideChange,
          touchEnd: () => {
            if (this.props.carouselStore.draggable) {
              this.props.isTap(false);
            }
          },
          tap: () => {
            if (this.props.carouselStore.draggable) {
              this.props.isTap(true);
            }
          },
          slidePrevTransitionStart: this.slidePrevTransitionStart,
          slideNextTransitionStart: this.slideNextTransitionStart,
          slideChangeTransitionEnd: this.slideTransitionEnd,
        },
        paginationClickable: false,
        slideToClickedSlide: false,
      },
    };
    this.analytics = [];
    this.adjustMenu = this.adjustMobileSlideMenu();
    if (window.zara && window.zara.mkt) {
      window.zara.mkt.setEditMode = mode => this.handleEditMode(mode);
    }
  }

  componentWillMount = () => {
    this.resizeDocument();
  };
  addBodyActiveSlideHandler = () => {
    if (window.swiper) {
      const swiperIndex = window.swiper && window.swiper.length > 1 ? window.selectedCarousel.realIndex : 0;
      const activeSwiperContext = window.swiper.find(sw => sw.idx === swiperIndex);
      if (activeSwiperContext) {
        const contentId = activeSwiperContext.slides[activeSwiperContext.activeIndex].getAttribute("data-content");
        document.body.setAttribute("data-slide", `${contentId}`);
      }
    }
  };

  componentDidMount = () => {
    bgColor(this.props);
    if (this.props.getSwiperContext) {
      this.props.getSwiperContext(this.swiper);
    }
    if (this.props.enhancement) {
      const fileName = this.props.dataAttrs ? this.props.dataAttrs["data-content"] : null;
      if (this.props.enhancement.init && !g.enhancementsLoaded.includes(this.props.enhancementName)) {
        try {
          this.props.enhancement.init(this);
          logger.log(`... enhancing content [${this.props.attrs.id}]`);
          g.enhancementsLoaded.push(this.props.enhancementName);
        } catch (error) {
          logger.error(`Enhancement error: ${this.props.attrs.id}`);
          logger.debug(error);
        }
      }
      if (fileName && this.props.enhancement[fileName] && this.props.enhancement[fileName].init) {
        try {
          this.props.enhancement[fileName].init();
          logger.log(`... enhancing content [${fileName}]`);
        } catch (error) {
          logger.error(`Enhancement error: ${fileName}`);
          logger.debug(error);
        }
      }
    }
    this.createAnalyics();
    window.addEventListener(features.phone ? "touchmove" : "scroll", this.handleScroll, false);
    window.addEventListener("resize", this.resizeDocument);
    this.handleScroll();
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.contents !== this.props.contents) {
      this.looped = false;
      logger.log("Carousel Update");
      this.forceUpdate();
    }
  };

  componentDidUpdate = () => {
    if (window.zara) {
      if (this.state.editMode) {
        window.zara.mkt.swiper = this.swiper;
      } else if (window.zara.mkt.swiper) {
        window.zara.mkt.swiper = null;
      }
    }
    // TODO MIRAR SI SE PUEDE CONTROLAR DESDE OTRO LADO
    const currentCarousel = `[data-content='${window.currentCarousel}']`;
    if (
      g.editMode &&
      document.querySelector(`${currentCarousel}`) &&
      document.querySelector(`${currentCarousel} .fa-pause`) &&
      document.querySelector(`${currentCarousel} .fa-pause`).classList.contains("active")
    ) {
      window.selectedCarousel.autoplay.stop();
    }
  };

  componentWillUnmount = () => {
    this.handleFooter("catalog-area");
    window.swiper = null;
    this.analytics = [];
    window.removeEventListener(features.phone ? "touchmove" : "scroll", this.handleScroll, false);
    window.removeEventListener("resize", this.resizeDocument);
  };

  getPropsFromContent = idx => {
    const content = this.props.contents[idx];
    return content.customProps || content || {};
  };

  getInitialSlide = () => {
    const contents = this.props.contents;
    const index = contents.map(x => x.customProps.sectionName).indexOf(defaultSection());
    const slideIndex = index > -1 ? index : 0;
    if (g.channels.mobile) {
      setTimeout(() => {
        this.adjustMenu("init", slideIndex);
      }, 500);
    }
    return slideIndex;
  };

  resizeDocument = () => {
    // changes size of document according to navigator bars
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  addToGlobal = () => {
    if (!window.swiper) {
      window.swiper = [];
      window.selectedCarousel = this.swiper;
      if (!window.swiper.destroyed) {
        window.currentCarousel = this.swiper.el.parentElement.id;
      }
    }
    if (window.selectedCarousel.destroyed || !document.getElementById(window.currentCarousel)) {
      window.selectedCarousel = this.swiper;
      window.currentCarousel = this.swiper.el.parentElement.id;
    }
    window.swiper.push(this.swiper);
    this.checkNode();
  };

  handleScroll = () => {
    if (this.swiper) {
      if (!g.editMode) {
        inView(".swiper-slide").check();
        this.scrollY = window.scrollY || window.pageYOffset;
        if (this.scrollY === 0 && !this.swiper.autoplay.running) {
          logger.log("Carousel Start");
          this.props.carouselPlayHandler(true, false);
        } else if (this.scrollY !== 0 && this.swiper.autoplay.running) {
          logger.log("Carousel Stop");
          this.props.carouselPlayHandler(false, true);
        }
      }
    }
  };

  handleEditMode = mode => {
    const autoplay = {
      delay: 3500,
      disableOnInteraction: true,
    };
    this.setState(
      prevState => ({
        ...prevState,
        editMode: mode,
        params: {
          ...prevState.params,
          autoplay: !mode ? autoplay : null,
          threshold: !mode ? null : 150,
        },
      }),
      () => {
        if (mode) {
          this.swiper.autoplay.stop();
        } else if (this.props.autoplay) {
          this.swiper.autoplay.start();
        }
      }
    );
  };

  handleVideos = () => {
    const slides = this.swiper.el.querySelectorAll(".swiper-slide");
    slides.forEach(slide => {
      if (slide !== slides[this.swiper.activeIndex]) {
        const allVideos = slide.querySelectorAll("video");
        for (const video of allVideos) {
          video.currentTime = 0;
          video.muted = true;
          video.pause();
        }
      } else {
        const allVideos = slide.querySelectorAll("video");
        for (const video of allVideos) {
          if (video.paused) {
            video.currentTime = 0;
            video.muted = true;
            video.play();
          }
        }
      }
    });
  };

  slideChange = () => {
    this.addBodyActiveSlideHandler();
    if (document.getElementsByClassName(".header-button")) {
      const previous = document.querySelector(".header-active");
      if (previous) previous.classList.remove("header-active");
      document.querySelector(`.header-button-${this.swiper.realIndex}`).classList.add("header-active");
    }

    const labelLeft = document.querySelector(".swiper-button-prev .label-button");
    if (labelLeft) labelLeft.innerHTML = "";

    const labelRight = document.querySelector(".swiper-button-next .label-button");
    if (labelRight) labelRight.innerHTML = "";

    const activeSlide = window.swiper && window.swiper[0].realIndex;

    labelLeft.innerHTML = (this.props.contents[activeSlide - 1] || this.props.contents[activeSlide]).customProps.slideTitle;

    labelRight.innerHTML = (this.props.contents[activeSlide + 1] || this.props.contents[activeSlide]).customProps.slideTitle;

    /**
    if (!this.swiper) return;
    if (!this.looped && this.props.loop) {
      this.looped = true;
      this.swiper.loopCreate();
    }
    inView(".swiper-slide").check();
    this.handleVideos();
    if (this.props.carouselStore.first) {
      this.instanceClonesHandler("first");
    }
    if (this.props.carouselStore.last) {
      this.instanceClonesHandler("last");
    }
    if (this.props.carouselStore.pausedOnFullscreen) {
      this.props.pausedOnFullscreen(false);
    }
    if (isHome() && document.getElementsByClassName(".header-button")) {
      const previous = document.querySelector(".header-active");
      if (previous) previous.classList.remove("header-active");
      document
        .querySelector(`.header-button-${this.swiper.realIndex}`)
        .classList.add("header-active");
    }
    selectSlideChangedCarousel();
     **/
  };

  handleWhiteMenu = () => {
    const swiperIndex = window.selectedCarousel.realIndex;
    const activeSwiperContext = window.swiper.find(sw => sw.idx === swiperIndex);
    const customProps = this.props.contents[swiperIndex].contents[activeSwiperContext.activeIndex].customProps;

    // TODO: ojo que venga lo que venga nos va a poner white
    if (customProps.bodyClassName) {
      dom.addBodyClass("white-menu");
    } else {
      dom.removeBodyClass("white-menu");
    }
  };

  /* eslint-disable max-statements */
  // makes no sense split this method and it ask to move half of methods
  createUI = () => {
    if (!window.swiper) return;
    if (document.querySelector(".label-button")) return;
    const activeSlide = window.swiper[0].params.initialSlide;
    const buttons = document.querySelectorAll(".header-button");
    if (window.swiper.length > 1 && buttons && buttons[activeSlide]) {
      buttons.forEach(x => x.classList.remove("header-active"));
      buttons[activeSlide].classList.add("header-active");
    }

    if (document.querySelector(".arrow-left")) {
      const arrowLeft = document.createDocumentFragment();
      arrowLeft.appendChild(document.querySelector(".arrow-left"));
      document.querySelector(".swiper-button-prev").appendChild(arrowLeft);
      document.querySelector(".swiper-button-prev").classList.add("_prevent-menu-unfold");
    }

    if (document.querySelector(".arrow-right")) {
      const arrowRight = document.createDocumentFragment();
      arrowRight.appendChild(document.querySelector(".arrow-right"));
      document.querySelector(".swiper-button-next").appendChild(arrowRight);
      document.querySelector(".swiper-button-next").classList.add("_prevent-menu-unfold");
    }

    // create a new div element
    let newSpan = document.createElement("span");
    // and give it some content
    let newContent = document.createTextNode(
      this.props.contents[activeSlide - 1]
        ? this.props.contents[activeSlide - 1].customProps.slideTitle
        : this.props.contents[activeSlide].customProps.slideTitle
    );
    // add the text node to the newly created div
    newSpan.appendChild(newContent);
    newSpan.classList.add("label-button");
    document.querySelector(".swiper-button-prev").appendChild(newSpan);

    // create a new div element
    newSpan = document.createElement("span");
    // and give it some content
    newContent = document.createTextNode(
      this.props.contents[activeSlide + 1]
        ? this.props.contents[activeSlide + 1].customProps.slideTitle
        : this.props.contents[activeSlide].customProps.slideTitle
    );
    // add the text node to the newly created div
    newSpan.appendChild(newContent);
    newSpan.classList.add("label-button");
    document.querySelector(".swiper-button-next").appendChild(newSpan);
  };

  hideFooter = () => {
    const footerBottom = document.querySelectorAll(".footer-bottom");
    if (footerBottom) {
      footerBottom.forEach(x => x.classList.add("hide-footer"));
    }

    g.footerItems.forEach(elem => {
      const element = document.querySelector(elem);
      if (element) element.classList.add("hide-footer");
    });
  };

  showFooter = () => {
    const footerBottom = document.querySelectorAll(".footer-bottom");
    if (footerBottom) {
      footerBottom.forEach(x => {
        x.classList.remove("hide-footer");
        x.classList.add("show-footer");
      });
    }

    const newsLetter = document.querySelector(".newsletter-wrapper");
    if (newsLetter) {
      newsLetter.classList.remove("hide-footer");
      newsLetter.classList.add("show-footer");
    }

    const terms = document.querySelector(".terms-cont");
    if (terms) {
      terms.classList.remove("hide-footer");
      terms.classList.add("show-footer");
    }

    const mktFooter = document.getElementById("mkt-footer");
    if (mktFooter) {
      mktFooter.classList.remove("hide-footer");
      mktFooter.classList.add("show-footer");
    }

    // mobile
    const subscribe = document.getElementById("newsletter-subscribe-widget");
    if (subscribe) {
      subscribe.classList.remove("hide-footer");
      subscribe.classList.add("show-footer");
    }

    const network = document.getElementById("network-footer");
    if (network) {
      network.classList.remove("hide-footer");
      network.classList.add("show-footer");
    }

    const privacy = document.querySelector(".privacy");
    if (privacy) {
      privacy.classList.remove("hide-footer");
      privacy.classList.add("show-footer");
    }

    const legal = document.getElementById("legal-footer");
    if (legal) {
      legal.classList.remove("hide-footer");
      legal.classList.add("show-footer");
    }

    // qr list cn
    const qrList = document.querySelector(".qr-list");
    if (qrList) {
      qrList.classList.remove("hide-footer");
      qrList.classList.add("show-footer");
    }
  };

  triggerAnalytics = () => {
    const currentSlide = this.swiper.realIndex;
    const currentSlideChild = window.swiper && window.swiper[currentSlide + 1].realIndex;
    const analytic = this.analytics[currentSlide][currentSlideChild];
    if (analytic) api.trackEvent(analytic);
  };

  triggerSectionAnalytics = () => {
    if (!this.swiper) return null;
    const idxPrev = this.swiper.previousIndex;
    const idx = this.swiper.realIndex;
    const propsBefore = this.getPropsFromContent(idxPrev);
    const props = this.getPropsFromContent(idx);
    if (props) {
      const sectionAnalytics = {
        category: `Home_${propsBefore.sectionName.toLowerCase()}`,
        action: "Section_change",
        label: toCamelCase(props.sectionName),
      };
      api.trackEvent(sectionAnalytics);
    }
  };

  handleFooter = page => {
    const target = page || `slide-footer-${this.swiper.realIndex || 0}`;
    const destination = document.getElementById(target);

    if (!destination) return;

    const footer = document.createDocumentFragment();

    // Append desired element to the fragment:
    g.footerItems.forEach(elem => {
      const element = document.querySelector(elem);
      if (element) footer.appendChild(element);
    });

    // Append fragment to desired element:
    destination.appendChild(footer);
  };
  /* eslint-disable no-unused-vars */
  slideTransition = (idx, nextProps, prevProps) => {
    this.handleWhiteMenu();
    this.hideFooter();
    document.body.setAttribute("data-ui", nextProps.uiColor || "");
    /**
    dom.removeClass(document.body, prevProps.bodyClassName);
    dom.addClass(document.body, nextProps.bodyClassName);
     **/
    if (this.props.scenes && this.swiper) {
      const hasWhiteBg = this.swiper.slides[idx].nextSibling
        ? this.swiper.slides[idx].nextSibling.querySelector(".white")
        : this.swiper.slides[idx].querySelector(".white");
      if (hasWhiteBg) {
        this.props.changeUI("white");
      } else {
        this.props.changeUI("black");
      }
    }
    if (window.swiper && window.swiper.length > 1) {
      const activeSwiper = window.swiper.filter(({ params }) => params.sectionName === nextProps.sectionName).reduce(sw => sw);
      const activeSwiperSlide = activeSwiper.activeIndex;
      this.handleSlideMessage(activeSwiper.params.contents[activeSwiperSlide]);
    }
  };

  adjustMobileSlideMenu = () => {
    let currentAmount = 0;
    let unitAmount = null;
    return (dir, slideIndex) => {
      const slideMenu = document.querySelector("#wrappers");
      if (slideMenu) {
        const slideMenuBounds = slideMenu.getBoundingClientRect();
        const activeButton = slideMenu.querySelector(".header-active");
        const items = slideMenu.querySelectorAll(".header-button");
        const deviceWidth = window.innerWidth;
        if (activeButton && slideMenuBounds.width > deviceWidth) {
          if (!slideMenu.parentNode.classList.contains("adjusted")) slideMenu.parentNode.classList.add("adjusted");
          const activeIndex = Number(activeButton.getAttribute("class").match(/button-(\d)/)[1]);
          if (!unitAmount) {
            unitAmount = Math.ceil((Math.ceil(slideMenuBounds.width) - deviceWidth) / items.length);
          }
          if (dir === "init") {
            currentAmount = unitAmount * slideIndex;
          } else if (dir === "right") {
            currentAmount += unitAmount;
          } else {
            if (activeIndex - 1 !== 0) {
              currentAmount -= unitAmount;
            } else {
              currentAmount = 0;
            }
          }
          slideMenu.style.transform = `translateX(-${currentAmount}px)`;
        }
      }
    };
  };

  slideTransitionEnd = () => {
    this.slideChange();
    this.handleFooter();
    this.showFooter();
    this.triggerAnalytics();
    this.triggerSectionAnalytics();
    const activeIndex = window.swiper && window.swiper[0].realIndex + 1;
    const wrappers = document.querySelector("#wrappers");
    if (window.swiper && window.swiper[activeIndex].slides.length !== window.swiper[activeIndex].realIndex + 1) {
      if (wrappers) wrappers.classList.remove("hide");
      document.querySelector(".swiper-button-next").classList.remove("hide");
      document.querySelector(".swiper-button-prev").classList.remove("hide");
    } else {
      if (wrappers) wrappers.classList.add("hide");
      document.querySelector(".swiper-button-next").classList.add("hide");
      document.querySelector(".swiper-button-prev").classList.add("hide");
    }
    if (window.sectionPersistence) {
      window.sectionPersistence.updatePromotedSectionInfo(this.props.contents[this.swiper.realIndex].customProps.sectionName);
    }
  };

  slideNextTransitionStart = () => {
    if (g.channels.mobile) {
      this.adjustMenu("right");
    }
    const idx = this.swiper ? this.swiper.realIndex : 0;
    const nextProps = this.getPropsFromContent(idx);
    const prevProps = this.getPropsFromContent((idx || this.props.contents.length) - 1);
    this.slideTransition(idx, nextProps, prevProps);
  };

  slidePrevTransitionStart = () => {
    if (g.channels.mobile) {
      this.adjustMenu("left");
    }
    const idx = this.swiper ? this.swiper.realIndex : 0;
    const nextProps = this.getPropsFromContent(idx);
    const prevProps = this.getPropsFromContent(idx + 1 === this.props.contents.length ? 0 : idx + 1);
    this.slideTransition(idx, nextProps, prevProps);
  };

  checkNode = () => {
    if (this.swiper && !this.swiper.autoplay.running && this.props.autoplay) {
      this.swiper.autoplay.start();
    }
  };

  createAnalyics = () => {
    this.props.contents.forEach((carousel, i) => {
      let analyticBySlide = [];
      carousel.contents.forEach((m, k) => {
        const analytic = getAnalyticsSpot(m, k, carousel.customProps.sectionName);
        analyticBySlide.push(analytic);
      });
      this.analytics[i] = analyticBySlide;
      analyticBySlide = [];
    });
  };

  instanceClonesHandler = pos => {
    // TODO: queryselector must be select current carousel
    const slides = document.querySelectorAll("div.swiper-slide");
    const clone = pos === "first" ? slides[slides.length - 1] : slides[0];
    ReactDOM.unmountComponentAtNode(clone);
    ReactDOM.render(
      <Provider store={store}>
        <Dynamic {...this.props.carouselStore[pos]} clone />
      </Provider>,
      clone
    );
    this.props.cloneMounted(pos);
  };

  nestedTransition = transitioning => {
    if (transitioning) {
      this.swiper.slideToClosest(1000);
    }
  };
  handleSlideMessage = ({ footer }) => {
    if (footer) {
      if (!this.props.userOpened) this.props.closeMessage(this.props.seenMessages.has(footer.content.content));
      this.props.changeMessage({ title: footer.content.title, content: footer.content.content || footer.content.text });
    } else if (
      (this.props.default &&
        this.props.default.content &&
        this.props.seenMessages.has(this.props.default.content) &&
        !this.props.userOpened &&
        !this.props.closed) ||
      (!footer && !this.props.closed)
    ) {
      this.props.closeMessage(true);
      this.props.changeMessage(this.props.default || { title: "", content: "" });
    } else {
      this.props.changeMessage(this.props.default || { title: "", content: "" });
    }
  };

  render = () => {
    if (this.swiper) {
      if (!this.props.scenes) {
        if (!this.props.carouselStore.running) {
          this.swiper.autoplay.stop();
        } else if (this.props.autoplay) {
          this.swiper.autoplay.start();
        }
      }
      this.swiper.allowTouchMove = !(!this.props.carouselStore.draggable || g.editMode);
    }

    return (
      <div {...this.props.attrs} className={`${this.props.attrs.className}`} dir={g.direction}>
        <Swiper
          {...this.state.params}
          getSwiper={swiper => {
            this.swiper = swiper;
            this.addToGlobal();
            setTimeout(this.createUI, 1000);
          }}
          lazy
        >
          {this.props.contents.map((m, k) => {
            const style = {};
            if (!isHomeMobile()) {
              style.height = `${getRatio(m.ratio)}%`;
            }
            let dataLabel = "";
            if (m.categoryUrl) {
              dataLabel = m.categoryUrl.match("'(.*)'")[1];
            }
            let openMenu;
            if (m.contentType !== "scenes") {
              openMenu = m.contents.filter(x => x.customProps && x.customProps.openMenu).length > 0;
            }

            return (
              <div
                key={k}
                data-swiper-autoplay={m.customProps.slideTime || 2500}
                style={this.props.fullscreenStyle}
                id={`item-${k + 1}`}
                data-position={k + 1}
                data-name={m.dataAttrs ? m.dataAttrs["data-content"] || "" : ""}
                data-label={dataLabel}
                data-path={m.root || ""}
                className="item"
                {...m.dataAttrs}
              >
                <Dynamic
                  {...m}
                  index={k}
                  openMenu={openMenu}
                  carousel
                  carouselIndex={k}
                  willDuplicate={null}
                  nestedTransition={this.nestedTransition}
                />
              </div>
            );
          })}
        </Swiper>
      </div>
    );
  };
}

Carousel.defaultProps = {
  customProps: {},
};

Carousel.propTypes = {
  attrs: PropTypes.object,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
    })
  ),
};
const mapStateToProps = state => ({
  carouselStore: state.carouselStore,
  seenMessages: state.carouselStore.message.seenMessages,
  userOpened: state.carouselStore.message.userOpened,
  default: state.carouselStore.message.default,
});

const mapDispatchToProps = dispatch => ({
  isTap: boolValue => dispatch(isTap(boolValue)),
  carouselPlayHandler: (running, scrolled) => dispatch(carouselPlayHandler(running, scrolled)),
  cloneMounted: position => dispatch(cloneMounted(position)),
  pausedOnFullscreen: paused => dispatch(pausedOnFullscreen(paused)),
  changeMessage: slideMessage => dispatch(changeMessage(slideMessage)),
  closeMessage: closed => dispatch(closeMessage(closed)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);
